import React, { useEffect, useState } from "react";
import AddCircleIcon from "@mui/icons-material/AddCircle";

import { GridColDef } from "@mui/x-data-grid";
import api from "../../../utils/Url";
import Card from "@mui/material/Card";
import {
    Box,
    Divider,
    Stack,
    Grid,
    Typography,
    Input,
    Button,
    TextField,
    Autocomplete,
    FormControl,
    RadioGroup,
    FormControlLabel,
    Radio,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import Switch from "@mui/material/Switch";
import { useNavigate, useLocation } from "react-router-dom";
import Chip from "@mui/material/Chip";
import { useTranslation } from "react-i18next";
import Paper from "@mui/material/Paper";
import { toast } from "react-toastify";
import ToastApp from "../../../ToastApp";
import DeleteIcon from "@mui/icons-material/Delete";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import CircularProgress from "@mui/material/CircularProgress";
import { useFormik } from "formik";
import * as Yup from "yup";
import { getId } from "../../../utils/Constant";
import ButtonWithLoader from "../../../utils/ButtonWithLoader";
import CustomLabel from "../../../CustomLable";
import Languages from "../../../Languages";
import { Language } from "react-transliterate";
import "react-transliterate/dist/index.css";
import TranslateTextField from "../../../TranslateTextField";
// import CustomDataGrids from "../../../utils/CustomDataGrids";
import CustomDataGrid from "../../../utils/CustomDatagrid";
import DataGrids from "../../../utils/Datagrids";
import { format } from 'date-fns';
import PrintIcon from '@mui/icons-material/Print';


import jsPDF from "jspdf";
import * as XLSX from "xlsx";


interface MenuPermission {
    isAdd: boolean;
    isEdit: boolean;
    isPrint: boolean;
    isDel: boolean;
}

export default function ComplaintsReport() {
    const Userid = getId();
    let navigate = useNavigate();
    const [editId, setEditId] = useState(-1);
    const [zones, setZones] = useState([]);
    const [columns, setColumns] = useState<any>([]);
    const [isLoading, setIsLoading] = useState(true);
    const location = useLocation();
    const [lang, setLang] = useState<Language>("en");
    const [permissionData, setPermissionData] = useState<MenuPermission>({
        isAdd: false,
        isEdit: false,
        isPrint: false,
        isDel: false,
    });

    const [selectedFormat, setSelectedFormat] = useState<any>("pdf");
    const [isPrint, setPrint] = useState([]);
    const [isHovered, setIsHovered] = useState(false);







    const { t } = useTranslation();



    const [Option, setOption] = useState([
        { value: "-1", label: t("text.SelectZone") },
    ]);

    const [taxOption, setTaxOption] = useState([
        { value: "-1", label: t("text.SelectWard") },
    ]);


    const [IsEmp, setEmp] = useState([
        { value: "-1", label: t("text.SelectEmployee") },
    ]);

    const [IsStatus, setStatus] = useState([
        { value: "-1", label: t("text.Status") },
    ]);

    const [Iscomplaint, setComplaint] = useState([
        { value: "-1", label: t("text.SelectComplaintNo") },
    ]);




    useEffect(() => {
        fetchZonesData();

        getEmployee();
        getZone();

        getComplaint();
        getCompStatus();
    }, []);



    const handleFormatChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSelectedFormat((event.target as HTMLInputElement).value);
    };

    const downloadTabularExcel = () => {
        if (!isPrint || isPrint.length === 0) {
            console.error("No data to export to Tabular HTML.");
            return;
        }

        // Prepare headers and rows for HTML table
        const headers = [
            "Complaint Type",
            "Zone Name",
            "Ward Name",
            "Complaint Date",
            "Employee Name",
            "Complaint No",
            "Complaint",
            "Complaints Status",

        ];

        const rows = isPrint.map((item: any, index: any) => [

            item?.compTypeName || "",
            item.zoneName.slice(0, 10),
            item?.wardName ? `${item.wardName} (${item.wardNo})` : "_ _",
            item?.complaintDate.slice(0, 10) || "",

            item.empName,
            item?.complaintNo || "",
            item?.complaint || "",
            item?.compStatusName || "",
        ]);

        // Create HTML table with enhanced styles and icons
        let html = `
          <html>
            <head>
              <meta charset="UTF-8">
              <meta name="viewport" content="width=device-width, initial-scale=1.0">
              <title>Complaint Report</title>
              <!-- Include FontAwesome icons for visuals -->
              <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css">
              <style>
                body {
                  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
                  background-color: #f0f4f7;
                  color: #333;
                  margin: 0;
                  padding: 0;
                }
                .report-container {
                  width: 95%;
                  max-width: 1200px;
                  margin: 40px auto;
                  background-color: #ffffff;
                  border-radius: 10px;
                  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
                  padding: 40px;
                  padding-bottom: 60px;
                }
                .header {
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  margin-bottom: 30px;
                }
                .logo {
                  max-width: 150px;
                  height: auto;
                }
                .header-title {
                  text-align: center;
                  color: #1a73e8;
                  font-size: 28px;
                  font-weight: 600;
                  flex-grow: 1;
                }
                .generated-date {
                  color: #888;
                  font-size: 14px;
                }
                table {
                  width: 100%;
                  border-collapse: collapse;
                  margin-bottom: 30px;
                }
                th {
                  background-color: #1a73e8;
                  color: white;
                  font-weight: bold;
                  padding: 16px;
                  text-align: left;
                  border: 1px solid #ddd;
                  text-transform: uppercase;
                }
                td {
                  padding: 12px;
                  text-align: left;
                  border: 1px solid #ddd;
                  font-size: 16px;
                  color: #333;
                }
                tr:nth-child(even) {
                  background-color: #f7f7f7;
                }
                tr:hover {
                  background-color: #f1f1f1;
                }
                .footer {
                  text-align: center;
                  font-size: 14px;
                  color: #888;
                  margin-top: 40px;
                }
                .footer a {
                  color: #1a73e8;
                  text-decoration: none;
                }
                .footer a:hover {
                  text-decoration: underline;
                }
                .page-footer {
                  font-size: 12px;
                  color: #aaa;
                  margin-top: 40px;
                }
              </style>
            </head>
            <body>
              <div class="report-container">
                <!-- Header Section: Logo, Title, Date -->
                <div class="header">
                  <img class="logo" src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQQb4HkK_VJ8hgOaOz_hcsBXPslnFWgCrfxFg&s" alt="Company Logo">
                  <div class="header-title">Complaint Report</div>
                  <div class="generated-date">
                    Generated on: ${new Date().toLocaleDateString("en-GB")}
                  </div>
                </div>
                
                <!-- Table Section -->
                <table>
                  <thead>
                    <tr>
                      ${headers.map((header) => `<th>${header}</th>`).join("")}
                    </tr>
                  </thead>
                  <tbody>
                    ${rows
                .map(
                    (row: any) =>
                        `<tr>${row
                            .map(
                                (cell: any) =>
                                    `<td>${cell}</td>`
                            )
                            .join("")}</tr>`
                )
                .join("")}
                  </tbody>
                </table>
                
                <div class="footer">
                  <p>Company Name | <a href="mailto:support@company.com">Contact Us</a></p>
                </div>
              </div>
            </body>
          </html>
        `;

        // Create a Blob from the HTML string and trigger the download
        const blob = new Blob([html], { type: "text/html" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "Complaint_Report_tabular.html";
        link.click();
    };



    const downloadExcel = () => {
        if (!isPrint || isPrint.length === 0) {
            console.error("No data to export to Excel.");
            return;
        }

        const ws = XLSX.utils.json_to_sheet(isPrint);

        const headers = Object.keys(isPrint[0]);

        headers.forEach((header, index) => {
            const cellAddress = `${String.fromCharCode(65 + index)}1`;
        });

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "reports");

        XLSX.writeFile(wb, "Complaint_Report.xlsx");
    };

    // Function to download PDF

    // Handle Download Button Click
    const handleDownload = () => {
        if (selectedFormat === "excel") {
            downloadExcel();
        } else if (selectedFormat === "pdf") {
            downloadPDF();
        } else if (selectedFormat === "tabular") {
            downloadTabularExcel();
        }
    };

    const downloadPDF = () => {
        if (!isPrint || isPrint.length === 0) {
            console.error("No data to export to PDF.");
            return;
        }

        // Initialize jsPDF with 'landscape' orientation
        const doc = new jsPDF("landscape"); // This sets the page orientation to landscape
        let yPosition = 10;
        const headerFontSize = 14;
        const bodyFontSize = 12;

        doc.setFontSize(headerFontSize);
        doc.setFont("helvetica", "bold");
        doc.text("Complaint Report", 14, yPosition);
        yPosition += 10;

        const headers = ["Complaint Type", "Zone Name", "Ward Name", "Complaint Date", "Employee Name", "Complaint No", "Complaint", "Complaint Status"];

        const columnWidths = [50, 50, 50, 50, 50, 50, 50, 50];

        const headerHeight = 8;
        const headerY = yPosition;
        doc.setFillColor(200, 220, 255);
        doc.rect(
            14,
            headerY,
            columnWidths.reduce((a, b) => a + b, 0),
            headerHeight,
            "F"
        );

        doc.setFont("helvetica", "bold");
        headers.forEach((header, index) => {
            doc.text(
                header,
                14 + columnWidths.slice(0, index).reduce((a, b) => a + b, 0),
                yPosition + headerHeight - 2
            );
        });

        const headerBottomMargin = 6;
        yPosition += headerHeight + headerBottomMargin;

        // Add table rows
        doc.setFontSize(bodyFontSize);
        doc.setFont("helvetica", "normal");

        isPrint.forEach((item: any, rowIndex) => {
            const row = [

                item?.compTypeName || "",

                item.zoneName,
                item?.wardName ? `${item.wardName} (${item.wardNo})` : "_ _",
                item?.complaintDate.slice(0, 10) || "",

                item.empName,
                item?.complaintNo || "",
                item?.complaint || "",

                item.compStatusName,


            ];

            row.forEach((cell, colIndex) => {
                const xOffset =
                    14 + columnWidths.slice(0, colIndex).reduce((a, b) => a + b, 0);
                if (cell) {
                    doc.text(cell.toString(), xOffset, yPosition);
                }
            });
            yPosition += 10;

            if (yPosition > 180) {
                // Adjust this to your content size for landscape
                doc.addPage();
                yPosition = 10; // Reset position on new page
            }
        });

        // Save the generated PDF with a filename
        doc.save("MRN_Report.pdf");
    };




    const getZone = async () => {
        const collectData = {
            zoneID: -1,
            user_ID: "",
        };
        const res = await api.post(`Zone/GetZonemaster`, collectData);
        const arr =
            res?.data?.data?.map((item: any) => ({
                label: item.zoneName,
                value: item.zoneID,
            })) || [];

        setOption(arr);
    };

    const getWardData = async (Id: any) => {
        const collectData = {
            areaID: -1,
            zoneID: Id
        };
        const res = await api.post(`AreaWardMaster/GetAreaWardMaster`, collectData);
        const arr =
            res?.data?.data?.map((item: any) => ({
                label: item.areaName,
                value: item.areaID,
            })) || [];

        setTaxOption(arr);
    };


    const getCompStatus = async () => {
        const collectData = {
            "id": -1,

        };
        const res = await api.post(`statusmaster/GetStatusMaster`, collectData);
        const arr =
            res?.data?.data?.map((item: any) => ({
                label: item.status,
                value: item.id,
            })) || [];

        setStatus(arr);
    };


    const getComplaint = async () => {
        const collectData = {
            "compId": -1,
            "empId": -1,
            "zoneid": -1,
            "wardid": -1,
            "compTypeId": -1,
            "complaintNo": "",
            "fromDate": null,
            "toDate": null,
            "compStatusId": -1,
            "show": true,
            "exportOption": ".pdf"
        };
        const res = await api.post(`ComplaintItem/GetComplaintItem`, collectData);
        const arr =
            res?.data?.data?.map((item: any) => ({
                label: item.complaintNo,
                value: item.compId,
            })) || [];

        setComplaint(arr);
    };




    const getEmployee = async () => {
        const collectData = {
            "empid": -1, "userId": "", "empName": "", "empMobileNo": "", "empDesignationId": -1, "empDeptId": -1, "empStateId": -1, "empCountryID": -1, "empCityId": -1, "empPincode": 0, "roleId": ""
        };
        const res = await api.post(`EmpMaster/GetEmpmaster`, collectData);
        const arr =
            res?.data?.data?.map((item: any) => ({
                label: item.empName,
                value: item.empid,
            })) || [];

        setEmp(arr);
    };









    const formik = useFormik({
        initialValues: {
            "itemId": -1,
            "poleNo": "",
            "zoneid": -1,
            "wardid": -1,
            "empid": -1,
            "fromDate": null,
            "toDate": null,
            complaintNo: "",
            compStatusId: -1


        },
        // validationSchema: validationSchema,
        onSubmit: async (values) => {

        },
    });



    const fetchZonesData = async () => {

        try {
            const collectData = {
                "compId": -1,
                "empId": formik.values.empid,
                "zoneid": formik.values.zoneid,
                "wardid": formik.values.wardid,
                "compTypeId": -1,
                "complaintNo": formik.values.complaintNo,
                "fromDate": formik.values.fromDate,
                "toDate": formik.values.toDate,
                "compStatusId": formik.values.compStatusId,
                "show": true,
                "exportOption": ".pdf"
            };
            const response = await api.post(`ComplaintItem/GetComplaintItem`, collectData);
            const data = response.data.data;

            const Print = data.map((item: any, index: any) => ({
                ...item,
            }));
            setPrint(Print);
            // console.log("🚀 ~ fetchZonesData ~ response.data.data:", response.data.data)
            const zonesWithIds = data.map((zone: any, index: any) => ({
                ...zone,
                serialNo: index + 1,
                id: zone.compId,
                wardWithNumber: zone.wardName ? `${zone.wardName} (${zone.wardNo})` : "_ _"
            }));
            setZones(zonesWithIds);
            setIsLoading(false);

            if (data.length > 0) {
                const columns: GridColDef[] = [


                    {
                        field: "serialNo",
                        headerName: t("text.SrNo"),
                        flex: 1,
                        // headerClassName: "MuiDataGrid-colCell",
                    },
                    {
                        field: "compTypeName",
                        headerName: t("text.ComplaintType"),
                        flex: 1,
                        // headerClassName: "MuiDataGrid-colCell",
                    },

                    {
                        field: "zoneName",
                        headerName: t("text.zoneName"),
                        flex: 1,
                        // headerClassName: "MuiDataGrid-colCell",
                    },
                    {
                        field: "wardWithNumber",
                        headerName: t("text.wardName"),
                        flex: 1,
                    },

                    {
                        field: "complaintDate",
                        headerName: t("text.ComplaintDate"),
                        valueFormatter: (params) => {
                            const date = new Date(params.value);
                            return date ? format(date, 'dd-MM-yyyy') : '__';
                        },
                        flex: 1,
                        // headerClassName: "MuiDataGrid-colCell",
                    },

                    {
                        field: "empName",
                        headerName: t("text.EmployeeName"),
                        flex: 1,
                        // headerClassName: "MuiDataGrid-colCell",
                    },
                    {
                        field: "complaintNo",
                        headerName: t("text.ComplaintNo"),
                        flex: 1,
                        // headerClassName: "MuiDataGrid-colCell",
                    },
                    {
                        field: "complaint",
                        headerName: t("text.ComplaintDescription"),
                        flex: 1,
                        // headerClassName: "MuiDataGrid-colCell",
                    },

                    {
                        field: "compStatusName",
                        headerName: t("text.ComplaintStatus"),
                        flex: 1,

                        headerClassName: "MuiDataGrid-colCell",
                    },


                ];
                setColumns(columns as any);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const adjustedColumns = columns.map((column: any) => ({
        ...column,
    }));



    return (
        <>
            <Card
                style={{
                    width: "100%",
                    backgroundColor: "lightgreen",
                    border: ".5px solid #2B4593",
                    marginTop: "3vh",
                }}
            >
                <Paper
                    sx={{
                        width: "100%",
                        overflow: "hidden",
                    }}
                    style={{ padding: "10px" }}
                >
                    <ConfirmDialog />

                    <Grid item xs={12} container spacing={1}>
                        <Grid item lg={10} md={10} xs={12}>
                            <Typography
                                gutterBottom
                                variant="h5"
                                component="div"
                                sx={{ padding: "20px" }}
                                align="left"
                            >
                                {t("text.ComplaintReport")}
                            </Typography>
                        </Grid>
                    </Grid>

                    <Divider />

                    <Box height={10} />

                    <Stack direction="row" spacing={2} classes="my-2 mb-2">

                        {/* <Button
                onClick={routeChangeAdd}
                variant="contained"
                endIcon={<AddCircleIcon />}
                size="large"
                style={{backgroundColor:`var(--header-background)`}}
              >
                {t("text.add")}
              </Button> */}

                    </Stack>






                    <Grid
                        item
                        xs={12}
                        container
                        spacing={2}
                        sx={{ marginTop: "1%" }}
                    >
                        <Grid item sm={4} lg={4} xs={12}>
                            <Autocomplete
                                disablePortal
                                id="combo-box-demo"
                                options={Option}
                                //   value={
                                //     Option.find(
                                //       (option: any) => option.value === formik.values.stateId
                                //     ) || null
                                //   }
                                fullWidth
                                size="small"
                                onChange={(event, newValue: any) => {
                                    console.log(newValue?.value);

                                    formik.setFieldValue("zoneid", newValue?.value);
                                    // formik.setFieldValue("zoneName", newValue?.label);
                                    getWardData(newValue?.value)
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label={
                                            <CustomLabel
                                                text={t("text.SelectZone")}
                                                required={false}
                                            />
                                        }
                                    />
                                )}
                            />

                        </Grid>


                        <Grid item sm={4} lg={4} xs={12}>
                            <Autocomplete
                                disablePortal
                                id="combo-box-demo"
                                options={taxOption}
                                //   value={
                                //     Option.find(
                                //       (option: any) => option.value === formik.values.stateId
                                //     ) || null
                                //   }
                                fullWidth
                                size="small"
                                onChange={(event, newValue: any) => {
                                    console.log(newValue?.value);

                                    formik.setFieldValue("wardid", newValue?.value);
                                    //formik.setFieldValue("wardName", newValue?.label);

                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label={
                                            <CustomLabel
                                                text={t("text.SelectWard")}
                                                required={false}
                                            />
                                        }
                                    />
                                )}
                            />
                        </Grid>


                        <Grid item sm={4} lg={4} xs={12}>
                            <Autocomplete
                                disablePortal
                                id="combo-box-demo"
                                options={IsStatus}
                                //   value={
                                //     Option.find(
                                //       (option: any) => option.value === formik.values.stateId
                                //     ) || null
                                //   }
                                fullWidth
                                size="small"
                                onChange={(event, newValue: any) => {
                                    console.log(newValue?.value);

                                    formik.setFieldValue("compStatusId", newValue?.value);
                                    //formik.setFieldValue("wardName", newValue?.label);
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label={
                                            <CustomLabel
                                                text={t("text.Status")}
                                                required={false}
                                            />
                                        }
                                    />
                                )}
                            />
                        </Grid>


                        <Grid item sm={4} lg={4} xs={12}>
                            <Autocomplete
                                disablePortal
                                id="combo-box-demo"
                                options={Iscomplaint}
                                //   value={
                                //     Option.find(
                                //       (option: any) => option.value === formik.values.stateId
                                //     ) || null
                                //   }
                                fullWidth
                                size="small"
                                onChange={(event, newValue: any) => {
                                    console.log(newValue?.value);

                                    formik.setFieldValue("complaintNo", newValue?.label);
                                    //formik.setFieldValue("wardName", newValue?.label);
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label={
                                            <CustomLabel
                                                text={t("text.SelectComplaintNo")}
                                                required={false}
                                            />
                                        }
                                    />
                                )}
                            />
                        </Grid>


                        <Grid item sm={4} lg={4} xs={12}>
                            <Autocomplete
                                disablePortal
                                id="combo-box-demo"
                                options={IsEmp}
                                //   value={
                                //     Option.find(
                                //       (option: any) => option.value === formik.values.stateId
                                //     ) || null
                                //   }
                                fullWidth
                                size="small"
                                onChange={(event, newValue: any) => {
                                    console.log(newValue?.value);

                                    formik.setFieldValue("empid", newValue?.value);
                                    //formik.setFieldValue("wardName", newValue?.label);
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label={
                                            <CustomLabel
                                                text={t("text.SelectEmployee")}
                                                required={false}
                                            />
                                        }
                                    />
                                )}
                            />
                        </Grid>


                        <Grid item sm={4} lg={4} xs={12}>
                            <TextField
                                label={<CustomLabel text={t("text.FromDate")} />}
                                value={formik.values.fromDate}
                                name="fromDate"
                                id="fromDate"
                                placeholder={t("text.FromDate")}
                                size="small"
                                fullWidth
                                type="date"
                                style={{ backgroundColor: "white" }}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                InputLabelProps={{ shrink: true }}
                            />
                        </Grid>

                        <Grid item sm={4} lg={4} xs={12}>
                            <TextField
                                label={<CustomLabel text={t("text.ToDate")} />}
                                value={formik.values.toDate}
                                name="toDate"
                                id="toDate"
                                placeholder={t("text.ToDate")}
                                type="date"
                                size="small"
                                fullWidth
                                style={{ backgroundColor: "white" }}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                InputLabelProps={{ shrink: true }}
                            />
                        </Grid>




                        <Grid item xs={12} lg={4}>

                            <Button
                                type="submit"
                                variant="contained"
                                fullWidth={true}
                                style={{
                                    // width: "60%",

                                    backgroundColor: `var(--header-background)`,
                                    //margin: "1%",
                                }}
                                onClick={() => {
                                    fetchZonesData();

                                }}
                            >
                                {t("text.show")}
                            </Button>


                        </Grid>

                        <Grid item xs={12} lg={4}></Grid>




                        <Grid item xs={12} lg={3.5}></Grid>


                        <Grid item xs={12} sm={4} lg={4}>
                            <FormControl component="fieldset">
                                <RadioGroup
                                    row
                                    value={selectedFormat}
                                    onChange={handleFormatChange}
                                >
                                    <FormControlLabel
                                        value="pdf"
                                        control={<Radio />}
                                        label="PDF"
                                    />
                                    <FormControlLabel
                                        value="excel"
                                        control={<Radio />}
                                        label="Excel"
                                    />
                                    <FormControlLabel
                                        value="tabular"
                                        control={<Radio />}
                                        label="Tabular Excel"
                                    />
                                </RadioGroup>
                            </FormControl>
                        </Grid>



                        <Grid
                            item
                            xs={12}
                            sm={1}
                            lg={1}
                            onMouseEnter={() => setIsHovered(true)}
                            onMouseLeave={() => setIsHovered(false)}
                            onClick={handleDownload}
                        >
                            <PrintIcon
                                style={{ color: isHovered ? "black" : "blue" }}
                                fontSize="large"
                            />
                        </Grid>



                        <Grid item xs={12} lg={3.5}></Grid>


                    </Grid>


                    <Grid
                        item
                        xs={12}
                        container
                        spacing={2}
                        sx={{ marginTop: "1%" }}
                    >
                        <Grid item sm={12} lg={12} xs={12}>

                            {isLoading ? (
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}
                                >
                                    <CircularProgress />
                                </div>
                            ) : (
                                <DataGrids
                                    isLoading={isLoading}
                                    rows={zones}
                                    columns={adjustedColumns}
                                    pageSizeOptions={[5, 10, 25, 50, 100]}
                                    initialPageSize={5}
                                />
                            )}

                        </Grid>
                    </Grid>
                </Paper>
            </Card>
            <ToastApp />
        </>
    );
}
